import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useSourcesMenuConfig } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuConfigContextSupport.js';
import { useOpenConnectorModalBySourceId } from '#pplx/frontend/apps/ask/connectors/modal-navigation/useOpenConnectorModalBySourceId.js';
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { useSkillModal } from '#pplx/frontend/apps/ask/skills/hooks/useSkillModal.js';
import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { memo, useCallback } from 'react';
const ConnectorsEnableModal = Dynamic(async () => {
    const { ConnectorsEnableModal } = await import('#pplx/frontend/apps/ask/connectors/modals/ConnectorsEnableModal.js');
    return { default: ConnectorsEnableModal };
});
const TemplateSetupModal = Dynamic(async () => {
    const { TemplateSetupModal } = await import('#pplx/frontend/apps/ask/connectors-list/TemplateSetupModal.js');
    return { default: TemplateSetupModal };
});
export const SourcesMenuItemSource = memo(function SourcesMenuItemSource({ source, enabled, onToggle, getIsSourceConnected, getSource }) {
    const reason = 'sources-menu-item-source';
    const { label, getIcon, description } = useSourceMeta({ sourceId: source });
    const icon = getIcon('small');
    const isConnected = getIsSourceConnected(source);
    const apiSource = getSource(source);
    const { openModal } = useModalContext();
    const openConnectorModal = useOpenConnectorModalBySourceId({
        reason: 'skill-modal-connector',
        openModal,
    });
    const openSkillModal = useSkillModal({ openModal, openConnectorModal });
    const openPaywallUpsell = usePaywallUpsell();
    const { hideDescriptionOverlays } = useSourcesMenuConfig();
    const handleOpenPaywall = useCallback(() => {
        openPaywallUpsell({
            origin: ModalOrigin.SOURCES_VIEW_MORE,
        });
    }, [openPaywallUpsell]);
    const isTemplate = apiSource?.is_template === true &&
        'required_fields' in apiSource &&
        Array.isArray(apiSource.required_fields) &&
        apiSource.required_fields.length > 0;
    const onSelect = useCallback(() => {
        if (isTemplate && apiSource) {
            openModal(TemplateSetupModal, {
                templateId: apiSource.id,
                templateName: apiSource.display_name || source,
                templateDescription: apiSource.description ?? '',
                templateAvatar: apiSource.icon_url ?? null,
                requiredFields: apiSource.required_fields ?? [],
            }, { replace: true });
            return;
        }
        openModal(ConnectorsEnableModal, {
            connectorName: source,
            connectorAvatar: apiSource?.icon_url ?? null,
            connectionType: apiSource?.connection_type ??
                null,
            referrer: 'ask',
            openInNewTab: true,
            reason,
            source: apiSource,
            handleOpenPaywall,
            openSkillModal,
        }, { replace: true });
    }, [openModal, source, apiSource, handleOpenPaywall, isTemplate, openSkillModal]);
    if (isTemplate || !isConnected) {
        const arrow = _jsx(Icon, { icon: $icon('arrow-up-right'), size: "small" });
        return (_jsx(DropdownMenu.Item, { leadingAccessory: icon, trailingAccessory: arrow, onSelect: onSelect, children: label }));
    }
    const menuItem = (_jsx(DropdownMenu.CheckboxItem, { leadingAccessory: icon, checked: enabled, onCheckedChange: onToggle, children: label }));
    if (description && !hideDescriptionOverlays) {
        return (_jsx(Tooltip, { content: description, side: "right", children: menuItem }));
    }
    return menuItem;
});
//# sourceMappingURL=SourcesMenuItemSource.js.map